import { message } from 'antd';
import { patchWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';

export const updateProfile = async (data: any, refetch?: () => void) => {
  console.log('Updating user profile with: ', data);
  try {
    const response = await patchWithCSRF(`${envApiUrl}/users/`, data);
    message.success('Successfully updated user profile');
    refetch?.();
    return response.data;
  } catch (err: any) {
    console.error('updateProfile error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || 'Failed to update profile');
  }
};
